<template>
  <div class="p-ex-center">
    <el-popover placement="bottom-end" popper-class="g_pop">
      <div class="pop-content">
        <div class="f-s-b">
          <div class="g_label">选择练习类型</div>
          <el-select v-model="subjectToCreate" width="80">
            <el-option
              v-for="subject in scienceSubjectList"
              :key="subject.id"
              :value="subject.id"
              :label="subject.name"
            ></el-option>
          </el-select>
        </div>
        <card-header>日常练习</card-header>
        <div class="g_card_container">
          <div class="g_card" @click="onCreateClick(3)">
            <img class="g_icon" src="../images/tb.png" alt="" />
            <div>
              <p class="g_title">日常同步练习</p>
              <p class="g_subtitle">海量题库，同步教材，自主选题</p>
            </div>
          </div>
          <div
            class="g_card"
            @click="onCreateClick(4)"
            v-if="scienceArr.includes(Number(this.subjectToCreate))"
          >
            <img class="g_icon" src="../images/ai.png" alt="" />
            <div>
              <p class="g_title">日常个性化练习</p>
              <p class="g_subtitle">设定条件，系统组题，个性化推荐练习</p>
            </div>
          </div>
        </div>
        <card-header class="mt-23">专项提升</card-header>
        <div class="g_card_container">
          <div
            class="g_card"
            @click="onCreateClick(6)"
            v-if="scienceArr.includes(Number(this.subjectToCreate))"
          >
            <img class="g_icon" src="../images/weak.png" alt="" />
            <div>
              <p class="g_title">薄弱知识点训练</p>
              <p class="g_subtitle">对班级阶段时间内的薄弱知识点进行复习</p>
            </div>
          </div>
          <div class="g_card" @click="onCreateClick(5)">
            <img class="g_icon" src="../images/common.png" alt="" />
            <div>
              <p class="g_title">高频错题训练</p>
              <p class="g_subtitle">对班级阶段时间内错误率高的题目进行复习</p>
            </div>
          </div>
        </div>
      </div>
      <button
        class="button--create"
        slot="reference"
        @click="getLastInfo"
      ></button>
    </el-popover>
    <card-header>练习中心</card-header>
    <div class="s-tabs">
      <div class="s-nav-container">
        <div class="s-tab-nav"></div>
      </div>
      <div class="hr"></div>
    </div>
    <div>
      <!-- <div class="s-form-item">
        <span class="s-form-item__label">所属年级：</span>
        <div>
          <span :class="getClass('grade', '')" @click="onChange('grade', '')"
            >全部</span
          >
          <span
            class="dot-span"
            :class="getClass('grade', item.academic_year_id)"
            v-for="item in gradeList"
            :key="item.academic_year_id"
            @click="onChange('grade', item)"
            >{{ item.name }}</span
          >
        </div>
      </div> -->
      <div class="s-form-item">
        <span class="s-form-item__label">所属班级：</span>
        <div class="s-form-item__hidden" ref="AllClass">
          <div ref="class" style="position: relative; top: -12px">
            <span
              :class="getClass('class', '')"
              class="s-form-item__text pointer"
              @click="onChange('class', '')"
            >
              全部
            </span>
            <span
              class="dot-span pointer"
              :class="getClass('class', item.id)"
              v-for="item in classList"
              :key="item.id"
              @click="onChange('class', item)"
              >{{ item.name }}</span
            >
          </div>
        </div>
        <span
          class="s-form-item__label blue pointer"
          v-if="!unfoldClass && unfoldShow"
          @click="unfold('class')"
        >
          展开
          <i class="el-icon-caret-bottom"></i>
        </span>
        <span
          class="s-form-item__label blue pointer"
          v-if="!unfoldClass && !unfoldShow"
          @click="packUp('class')"
        >
          收起
          <i class="el-icon-caret-top"></i>
        </span>
      </div>
      <div class="s-form-item">
        <span class="s-form-item__label">所属类型：</span>
        <div style="position: relative; top: -7px">
          <span
            :class="getClass('type', '')"
            @click="onChange('type', '')"
            class="s-form-item__text pointer"
            >全部</span
          >
          <span
            class="dot-span pointer"
            :class="getClass('type', item.id + item.sourceType)"
            v-for="item in typeList"
            :key="item.id + item.sourceType"
            @click="onChange('type', item)"
            >{{ item.name }}</span
          >
        </div>
      </div>
      <div class="s-form-item">
        <span class="s-form-item__label">所属学科：</span>
        <div style="position: relative; top: -8px">
          <span
            :class="getClass('subject', '')"
            @click="onChange('subject', '')"
            class="s-form-item__text pointer"
            >全部</span
          >
          <span
            class="dot-span pointer"
            :class="getClass('subject', item.id)"
            v-for="item in sortedSubjectList"
            :key="item.id"
            @click="onChange('subject', item)"
            >{{ item.name }}</span
          >
        </div>
      </div>
    </div>
    <footer class="search-footer">
      <span v-if="testList.length"
        >在当前筛选条件下，共搜索到 {{ total }} 条练习记录</span
      >
      <span v-else>当前搜索条件下没有找到任何练习，换个条件试试吧</span>
      <div>
        <el-input
          placeholder="请输入练习名称"
          clearable
          v-model="searchForm.testName"
        ></el-input>
        <el-button type="primary" @click="onSearchClick">查询</el-button>
      </div>
    </footer>
    <!-- table -->
    <div class="test-list">
      <test-panel
        v-for="item in testList"
        :data="item"
        :key="item.batch_id"
        toPage="teacher-report"
        @reload="getEvaluateList"
      />
      <div class="test-empty" v-if="!testList.length">
        <img src="../images/empty.png" alt="" />
        <p class="empty-text">暂无数据</p>
      </div>
    </div>
    <!-- 分页 -->
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :page-size.sync="pageSize"
      :page-sizes="[10, 50, 100]"
      :current-page.sync="currentPage"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getQueryString } from '@/utils/index';
import CardHeader from '@/components/card-header.vue';
import {
  getEvaluateList, getTeacherClass, getLastInfo, getExtraLastInfo,
} from '@/api/pt';
import { getSign } from '@/utils/verify';
import { scienceSubjectList } from '@/config/subject';
import mixins from '../mixins';
import TestPanel from '../components/test-panel.vue';

// const ascending = 1;
const descending = 0;
const TEACHER_ROLE = 6008003;
// const TOB = 1; // 渠道 1 tob 2运营平台

const EVALUATE_OR_PREVIEW = 1; // 1为测评 2为预习
export default {
  components: {
    CardHeader,
    TestPanel,
  },
  name: 'ExerciseCenter',
  mixins: [mixins],
  data() {
    const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
    return {
      searchForm: {
        grade: '',
        subject: '',
        class: { id: getQueryString('classId') } || '',
        version: '',
        stage: '',
        course: '',
        testName: '',
        type: '',
        sortBy: 'created',
        order: descending,
        sourceType: 1,
      },
      scienceSubjectList,
      subjectToCreate: '',
      total: 0, // 总数
      pageSize: 10,
      currentPage: 1,
      // 测试内容年级（阶段）列表
      stageList: [],
      // 可选科目
      subjectList: [],
      // 可选版本
      versionList: [],
      // 可选年级
      // gradeList: [],
      // 可选班级
      classList: [],
      // 可选课程
      courseList: [],
      // 测评列表
      testList: [],
      // 可选试题类型
      typeList: [
        // source_type      1:直接布置，2:高频错误布置，3:薄弱知识点布置
        { name: '同步练习', id: '3', sourceType: 1 },
        { name: '个性化练习', id: '4', sourceType: 1 },
        { name: '高频错题', id: '3', sourceType: 2 },
        { name: '薄弱知识点', id: '4', sourceType: 3 },
      ],
      unfoldShow: true,
      unfoldClass: false,
      isTeacher: userInfo.position === TEACHER_ROLE,
      isEvaluate: EVALUATE_OR_PREVIEW,
      queryLastData: {},
      scienceArr: [2, 4, 5],
      extraLastData: {},
    };
  },
  mounted() {
  },
  computed: {
    visibleTestSearch() {
      return !!this.searchForm.subject;
    },
    sortedSubjectList() {
      if (!this.subjectList || !this.subjectList.length) {
        return [];
      }
      return this.subjectList.map((item) => item).sort((a, b) => a.id - b.id);
    },
  },
  watch: {
    currentPage() {
      this.getEvaluateList();
    },
    pageSize() {
      this.getEvaluateList();
    },
    classList() {
      this.$nextTick(() => {
        console.log(this.$refs.class.offsetHeight, '高度');
        if (this.$refs.class.offsetHeight < 90) {
          this.unfoldClass = true;
        } else {
          this.unfoldClass = false;
        }
      });
    },
    'searchForm.grade': {
      immediate: true,
      handler(v) {
        getTeacherClass({
          id: (v && v.academic_year_id) || '',
        }).then((res) => {
          if (res.code === 200) {
            this.classList = res.data;
          }
        });
      },
    },
    searchForm: {
      deep: true,
      handler() {
        this.getEvaluateList();
      },
    },
  },
  created() {
    this.initData();
    this.getEvaluateList();
  },
  methods: {
    // 查询最后一次作业信息
    async queryLastInfo(type) {
      await getLastInfo({ type }).then((res) => {
        if (res.code === 200) {
          this.queryLastData = res.data;
        }
      });
      try {
        await getExtraLastInfo().then((res) => {
          if (res.code === 200) {
            this.extraLastData = res.data;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getLastInfo() {
      this.queryLastData = {};
      await this.queryLastInfo();
      // let categoryObj = {};
      // if (this.queryLastData.subject_id !== undefined) {
      //   this.subjectToCreate = this.queryLastData.subject_id;
      // }
      if (this.extraLastData.subject_id !== undefined) {
        this.subjectToCreate = Number(this.extraLastData.subject_id);
      } else if (this.queryLastData.subject_id !== undefined) {
        this.subjectToCreate = Number(this.queryLastData.subject_id);
      }
      if (this.queryLastData.updated < this.extraLastData.updated) {
        this.subjectToCreate = Number(this.extraLastData.subject_id);
      }
      if (this.queryLastData.updated > this.extraLastData.updated) {
        this.subjectToCreate = Number(this.queryLastData.subject_id);
      }
    },
    unfold(type) {
      if (type === 'class') {
        console.log(this.$refs.class.offsetHeight);
        this.unfoldShow = false;
        this.$refs.AllClass.style.height = `${this.$refs.class.offsetHeight}px`;
      }
    },
    packUp(type) {
      if (type === 'class') {
        this.unfoldShow = true;
        this.$refs.AllClass.style.height = '42px';
      }
    },
    getMasterClass(value) {
      // <!-- 【0，40）红色，【40，70）橙色，【70，100】绿色 -->
      if (value >= 70) {
        return 't--green';
      }
      if (value >= 40) {
        return 't--orange';
      }
      return 't--red';
    },
    async onCreateClick(type) {
      if (!this.subjectToCreate) {
        this.$message({
          message: '请选择教授学科',
          type: 'error',
          center: true,
        });
        return;
      }
      const subjectList = [
        { id: 1, name: '英语' },
        { id: 2, name: '数学' },
        { id: 3, name: '语文' },
        { id: 4, name: '物理' },
        { id: 5, name: '化学' },
      ];
      const subjectName = subjectList.find((item) => item.id === this.subjectToCreate).name;
      // 判断有没有上次布置信息
      // 薄弱知识点 高频错题无 lastInfo
      if (![5, 6].includes(type)) {
        await this.queryLastInfo(type);
      }
      let categoryObj = {};
      if (this.extraLastData.subject_id !== undefined) {
        categoryObj = {
          subjectId: this.extraLastData.subject_id,
          subjectName: this.extraLastData.subject_name,
          gradeId: this.extraLastData.grade_id,
          gradeName: this.extraLastData.grade_name,
          textbookId: this.extraLastData.textbook_id,
          textbookName: this.extraLastData.textbook_name,
          termId: this.extraLastData.term_id,
          termName: this.extraLastData.term_name,
          courseId: this.extraLastData.course_id,
          lastClassList: '',
        };
      } else if (this.queryLastData.subject_id !== undefined) {
        categoryObj = {
          subjectId: this.queryLastData.subject_id,
          subjectName: this.queryLastData.subject_name,
          gradeId: this.queryLastData.grade_id,
          gradeName: this.queryLastData.grade_name,
          textbookId: this.queryLastData.textbook_id,
          textbookName: this.queryLastData.textbook_name,
          termId: this.queryLastData.term_id,
          termName: this.queryLastData.term_name,
          lastClassList: this.queryLastData.evaluate_object,
        };
      } else {
        categoryObj = {
          subjectId: this.subjectToCreate,
          subjectName,
          gradeId: '',
          gradeName: '',
          textbookId: '',
          textbookName: '',
          termId: '',
          termName: '',
          lastClassList: '',
        };
      }
      if (this.queryLastData.updated < this.extraLastData.updated) {
        categoryObj = {
          subjectId: this.extraLastData.subject_id,
          subjectName: this.extraLastData.subject_name,
          gradeId: this.extraLastData.grade_id,
          gradeName: this.extraLastData.grade_name,
          textbookId: this.extraLastData.textbook_id,
          textbookName: this.extraLastData.textbook_name,
          termId: this.extraLastData.term_id,
          termName: this.extraLastData.term_name,
          courseId: this.extraLastData.course_id,
          lastClassList: '',
        };
      }
      if (this.queryLastData.updated > this.extraLastData.updated) {
        categoryObj = {
          subjectId: this.queryLastData.subject_id,
          subjectName: this.queryLastData.subject_name,
          gradeId: this.queryLastData.grade_id,
          gradeName: this.queryLastData.grade_name,
          textbookId: this.queryLastData.textbook_id,
          textbookName: this.queryLastData.textbook_name,
          termId: this.queryLastData.term_id,
          termName: this.queryLastData.term_name,
          lastClassList: this.queryLastData.evaluate_object,
        };
      }
      this.$store.commit('SET_CATEGORY_OBJ', categoryObj);
      this.$store.commit('SET_SUBJECT_OBJ', {
        subjectId: this.subjectToCreate,
        subjectName,
      });
      // 初始化mt试题篮和amt知识点选中列表
      this.$store.commit('CLEAR_QUESTIONS_BASKET', []);
      this.$store.commit('CHOOSE_KNOWLEDGE', []);
      this.$router.push({
        path: this.routeUrl(type),
        query: {
          fromType: type,
          exerciseType: true,
        },
      });
    },
    routeUrl(type) {
      const routerUrlList = {
        3: '/pt/create-mt',
        4: '/pt/create-at',
        5: '/pt/exercise-type-analyze?activeTab=CommonWrong',
        6: '/pt/exercise-type-analyze?activeTab=CommonWeak',
      };
      return routerUrlList[type];
    },
    // onSortChange(item) {
    //   // 无序默认按时间倒序
    //   if (!item.order) {
    //     this.searchForm.order = descending;
    //   } else {
    //     this.searchForm.sortBy = item.prop;
    //     this.searchForm.order = item.order === 'ascending' ? ascending : descending;
    //   }
    //   if (this.currentPage === 1) {
    //     this.getEvaluateList();
    //   } else {
    //     this.currentPage = 1;
    //   }
    // },
    onSizeChange(v) {
      this.pageSize = v;
      if (this.currentPage === 1) {
        this.getEvaluateList();
      } else {
        this.currentPage = 1;
      }
    },
    initData() {
      // 年级、班级
      // getTeacherYear().then((res) => {
      //   if (res.code === 200) {
      //     this.gradeList = res.data;
      //   }
      // });
      // 选课列表
      const typeList = ['subjects'];
      typeList.forEach((type) => {
        this.getCategory({ type, ...this.searchForm[type] });
      });
    },
    isCurrent(type, value) {
      if (!this.searchForm[type]) {
        return !value;
      }
      if (type === 'grade') {
        return this.searchForm.grade.academic_year_id === value;
      }
      if (type === 'type') {
        return (this.searchForm[type].id + this.searchForm[type].sourceType) === value;
      }
      return this.searchForm[type].id === value;
    },
    getClass(type, value) {
      return this.isCurrent(type, value) ? 'is-blue' : '';
    },
    onChange(type, item) {
      this.searchForm[type] = item;
    },
    onSearchClick() {
      this.getEvaluateList();
    },
    getEvaluateList() {
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      const data = {
        // re_from: TOB,
        school_id: userInfo.campusId,
        type: this.searchForm.type.id || '3,4',
        teacher_id: userInfo.id,
        role_id: userInfo.position,
        school_year: this.searchForm.grade.name || '',
        grade_id: this.searchForm.grade.id || '',
        class_id: this.searchForm.class.id || '',
        evaluate_name: this.searchForm.testName || '',
        subject_id: this.searchForm.subject.id || '',
        textbook_id: this.searchForm.version.id || '',
        test_grade_id: this.searchForm.stage.id || '',
        test_id: this.searchForm.course.id || '',
        page_size: this.pageSize,
        curr_page: this.currentPage,
        sort: this.searchForm.order,
        source_type: this.searchForm.type.sourceType,
      };
      return getEvaluateList({
        ...data,
        sign: getSign(data),
      }).then((res) => {
        if (res.code === 200) {
          this.testList = res.data.list;
          this.total = res.data.total;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.p-ex-center {
  padding: 32px 32px 100px;
  min-height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  background: #fff;
  position: relative;
  &__subtitle {
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
  }
  .empty-img {
    width: 160px;
  }
  .test-list {
    margin-top: 38px;
    min-height: 500px;
    .test-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #c0c4cc;
      font-size: 16px;
      img {
        width: 200px;
        margin-bottom: 20px;
      }
    }
  }
  .button--create {
    width: 121px;
    height: 40px;
    background-image: url("~@/views/pt/images/button_create_ex.png");
    background-size: 100% 100%;
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 2;
  }
  .search-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: rgba(48, 49, 51, 0.6);
    font-size: 14px;
    .el-button {
      border-radius: 0 4px 4px 0;
    }
    .el-input {
      width: 328px;
      vertical-align: bottom;
      /deep/ .el-input__inner {
        border-radius: 4px 0 0 4px;
      }
    }
  }
  .s-lg {
    width: 120px;
    height: 40px;
  }
  /deep/ .el-form-item__label {
    font-size: 16px;
    font-weight: 500;
  }
  /deep/ .el-table th {
    background: rgba(240, 242, 245, 1);
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
    font-weight: 500;
  }
  /deep/ .el-pagination {
    display: flex;
    position: absolute;
    width: calc(100% - 64px);
    bottom: 30px;
    left: 32px;
    .btn-prev {
      margin-left: auto;
    }
  }
  .search-tip {
    display: block;
    margin: -10px 0 0;
    width: 434px;
  }
  .s-form-item {
    font-size: 14px;
    display: flex;
    // align-items: center;
    padding: 20px 0;
    &:not(:last-of-type) {
      border-bottom: 1px dashed rgba(220, 225, 235, 1);
    }
    &__text {
      margin-right: 30px;
      line-height: 24px;
      padding: 7px 12px;
      &:hover {
        color: rgba(25, 137, 250, 1);
      }
    }
    &__hidden {
      overflow: hidden;
      line-height: 42px;
      height: 42px;
    }
    &__label {
      color: rgba(0, 0, 0, 1);
      font-weight: 400;
      line-height: 42px;
      font-size: 16px;
      width: 104px;
      min-width: 104px;
    }
    .blue {
      color: rgba(25, 137, 250, 1);
    }
    .is-blue {
      border-radius: 5px;
      background-color: rgba(25, 137, 250, 1);
      color: #fff;
      font-weight: 500;
      &:hover {
        color: #fff !important;
      }
    }
    .dot-span {
      padding: 7px 12px;
      box-sizing: border-box;
      // padding-left: 20px;
      display: inline-block;
      line-height: 24px;
      position: relative;
      margin-right: 30px;
      margin-top: 16px;
      white-space: nowrap;
      &:hover {
        color: rgba(25, 137, 250, 1);
      }
    }
  }
}
</style>
